// extracted by mini-css-extract-plugin
export default {"snackbar":"App_snackbar__Nbit3"};